
























import Vue from 'vue';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import SlideProduct from './SlideProduct.vue';
import config from '../../../../config';
import { IProduct } from '../../../common/interfaces/products.interface';
import { ISplideOptions } from '../../../common/interfaces/external.interface';
import { EProductSliderType } from '../../../common/enums/index.enum';
import { ISlideProductTexts } from '../../../common/interfaces/translations/component.translations.interface';
import { IStyleObject } from '../../../common/interfaces/index.interface';

export default Vue.extend({
  name: `ProductSlider`,
  components: { SlideProduct, Splide, SplideSlide },
  data() {
    return {
      splideOptions: {
        arrowPath: `M 8.75 37.523 L 28.573 17.7 L 31.05 20.177 L 11.227 40 Z M 8.75 2.477 L 11.227 0 L 31.05 20.177 L 28.573 22.3 Z`,
        breakpoints: {
          [config.breakpoints.maxMobile]: {
            perPage: 1,
            rewind: true,
          },
        },
        pagination: false,
        trimSpace: false,
      } as ISplideOptions,
      splideReady: false,
    };
  },
  computed: {
    noArrowsClass(): string {
      if(this.products.length < 2) {
        return `no-arrows`;
      }
      if(this.products.length < 5) {
        return `no-arrows-desktop`;
      }
      return ``;
    },
    sliderWidth(): IStyleObject {
      if(this.products.length > 4) {
        return { width: `100%` };
      }
      return { width: `${(this.products.length / 4) * 100}%` };
    },
  },
  props: {
    isPartner: {
      default: false,
      type: Boolean,
    },
    products: {
      required: true,
      type: Array as () => IProduct[],
    },
    shoppingAllowed: {
      default: true,
      type: Boolean,
    },
    texts: {
      required: true,
      type: Object as () => ISlideProductTexts,
    },
    type: {
      default: EProductSliderType.SQUARE,
      validator: val => Object.values(EProductSliderType).includes(val),
    },
  },
  mounted(): void {
    this.splideOptions.classes = {
      arrow: `splide__arrow my-splide-arrow`,
      arrows: `splide__arrows ${this.noArrowsClass}`,
    };
    const productsLength = this.products.length;
    this.splideOptions.perPage = productsLength < 5 ? productsLength : 4;
    this.splideOptions.type = productsLength < 5 ? `slide` : `loop`;
    this.splideReady = true;
  },
});
